import React, { useState } from "react";
import * as Yup from "yup";
import { useFormik } from "formik";
import AuthService from "services/AuthService";
import { useToasts } from "react-toast-notifications";
import { useUserContext } from "store/contexts/userContext";
import CustomInput from "components/CustomInput/CustomInput";
// import { Modal } from "react-responsive-modal";
import Button from "components/CustomButton";
import Loader from "components/Loader";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faLock, faEye, faEyeSlash } from "@fortawesome/free-solid-svg-icons";
// import { ReactComponent as Lock } from "assets/img/icons/lockSvg.svg";

var styles = {
  modalHeading: {
    color: "#ffa100",
    fontWeight: "700",
  },
  fullWidth: {
    width: "100%",
  },
  closeModal: {
    display: "flex",
    justifyContent: "flex-end",
  },
  resetPasswordError: {
    display: "flex",
    width: "100%",
    justifyContent: "center",
    flexDirection: "column",
    alignItems: "center",
    margin: "10px 0px",
  },
};

export default () => {
  const classes = styles;
  const { user } = useUserContext();
  const { addToast } = useToasts();
  const [loading, setLoading] = useState(false);
  const [showConfirmPassword, setShowConfirmPassword] = useState(false);
  const [showPassword, setShowPassword] = useState(false);
  const [oldPassword, setShowOldPassword] = useState(false);
  const [showError, setShowError] = useState(null);

  const formik = useFormik({
    initialValues: {
      old_password: "",
      password: "",
      password_confirmation: "",
    },
    validationSchema: Yup.object().shape({
      old_password: Yup.string().required("Old Password is required"),
      password: Yup.string()
        .matches(
          /^(?=.*[0-9])(?=.*[!@#$%^&*.])(?=.*[a-zA-Z])/,
          "password must contain 8-20 characters including letters, numbers & special characters."
        )
        .min(8, "Password cannot be less then 8 words")
        .max(20, "Password cannot be greater than 20 words")
        .required("Password is required"),
      password_confirmation: Yup.string()
        .equals([Yup.ref("password")], "Passwords Must Match")
        .required("Password confirmation is required"),
    }),
    onSubmit: async (values) => {
      try {
        setLoading(true);
        let all_values = {
          old_password: values.old_password,
          password: values.password,
          password_confirmation: values.password_confirmation,
          email: user.email,
        };
        await AuthService.resetPassword(all_values);

        addToast("Password changed successfully. ", { appearance: "success" });
        formik.resetForm();
      } catch (error) {
        setShowError(error.response.data.errors);
        addToast("password updated failed. ", { appearance: "error" });
      }
      setLoading(false);
    },
  });

  return (
    <form noValidate onSubmit={formik.handleSubmit}>
      {showError && (
        <div style={classes.resetPasswordError}>
          {Object.keys(showError).map((errors) => (
            <span style={{ color: "red" }}>
              {showError[errors]}
              <br />
            </span>
          ))}
        </div>
      )}
      <div className="col-md-8 col-sm-8 col-lg-8" style={classes.fullWidth}>
        <CustomInput
          id={"old_password"}
          inputClass="borderInput"
          startIcon={<FontAwesomeIcon icon={faLock} className="formIcon" />}
          inputProps={{
            type: oldPassword ? "text" : "password",
            placeholder: "Enter Old Password",
            ...formik.getFieldProps("old_password"),
            error:
              !!formik.errors.old_password && !!formik.touched.old_password
                ? formik.errors.old_password
                : null,
          }}
          endIcon={
            <FontAwesomeIcon
              onClick={() => setShowOldPassword(!oldPassword)}
              aria-label="toggle password visibility"
              icon={!oldPassword ? faEyeSlash : faEye}
              id="togglePassword"
              style={{ marginLeft: "-30px", cursor: "pointer" }}
            />
          }
        />
      </div>
      <div className="col-md-8 col-sm-8 col-lg-8" style={classes.fullWidth}>
        <CustomInput
          id={"Password"}
          inputClass="borderInput"
          startIcon={<FontAwesomeIcon icon={faLock} className="formIcon" />}
          inputProps={{
            type: showPassword ? "text" : "password",
            placeholder: "Enter New Password",
            ...formik.getFieldProps("password"),
            error:
              !!formik.errors.password && !!formik.touched.password
                ? formik.errors.password
                : null,
          }}
          endIcon={
            <FontAwesomeIcon
              onClick={() => setShowPassword(!showPassword)}
              aria-label="toggle password visibility"
              icon={!showPassword ? faEyeSlash : faEye}
              id="togglePassword"
              style={{ marginLeft: "-30px", cursor: "pointer" }}
            />
          }
        />
      </div>
      <div className="col-md-8 col-sm-8 col-lg-8" style={classes.fullWidth}>
        <CustomInput
          inputClass="borderInput"
          id={"password_confirmation"}
          startIcon={<FontAwesomeIcon icon={faLock} className="formIcon" />}
          inputProps={{
            type: showConfirmPassword ? "text" : "password",
            placeholder: "Confirm New Password",
            ...formik.getFieldProps("password_confirmation"),
            error:
              !!formik.errors.password_confirmation &&
              !!formik.touched.password_confirmation
                ? formik.errors.password_confirmation
                : null,
          }}
          endIcon={
            <FontAwesomeIcon
              onClick={() => setShowConfirmPassword(!showConfirmPassword)}
              icon={!showConfirmPassword ? faEyeSlash : faEye}
              style={{ marginLeft: "-30px", cursor: "pointer" }}
            />
          }
        />
      </div>
      <div className="col-md-8 col-sm-8 col-lg-8" style={classes.fullWidth}>
        <Button
          name={
            !loading ? "Update Password" : <Loader width={40} height={40} />
          }
          disabled={loading && true}
        />
      </div>
    </form>
  );
};
